/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const accessCode = (currentUser as any)?.access ?? currentUser?.user?.access;

  return {
    canAdmin: Boolean(currentUser) && accessCode === 'admin',
    // 支付路由不再做 partner 级前端拦截，统一交给登录态与后端业务规则控制。
    canAccessPayment: true,
  };
}
